var getConditionalAriaProp = function getConditionalAriaProp(propName, idsOrValues) {
  var _a;
  var existing = idsOrValues.filter(function (id) {
    return !!id;
  });
  if (existing.length > 0) {
    var ariaIdsOrValues = existing.join(' ').trim();
    return _a = {}, _a[propName] = ariaIdsOrValues, _a;
  }
  return {};
};

export { getConditionalAriaProp };
//# sourceMappingURL=aria.js.map
